import Heading from 'components/partials/heading/heading';
import Button from 'components/partials/button/button';

import UserPage from 'containers/admin/users/user/user-page/user-page';

import { useCurrentUser } from 'state/current-user/current-user.thunk';

import Icons from 'assets/icons';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

const Profile = (): React.JSX.Element => {
  const currentUser = useCurrentUser();

  return (
    <ResponsiveWrapper>
      <div className="flex items-center justify-between">
        <Heading variant="h1" customClass="mt-4">
          Your Profile Details
        </Heading>
        <Button
          variant="reserve-text"
          size="lg"
          iconBefore={<Icons.LogOut aria-hidden="true" />}
          className="mt-4 pr-0"
          onClick={() => currentUser.signOut()}
          data-testid="logout-button"
        >
          Log Out
        </Button>
      </div>

      <UserPage isCurrentUserProfile={true} />
    </ResponsiveWrapper>
  );
};

export default Profile;
